import { render } from "./BoxesWidget.vue?vue&type=template&id=7f736f3b&ts=true"
import script from "./BoxesWidget.vue?vue&type=script&lang=ts"
export * from "./BoxesWidget.vue?vue&type=script&lang=ts"

import "./BoxesWidget.vue?vue&type=style&index=0&id=7f736f3b&lang=css"

import exportComponent from "/github/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__